import React, { useState, useEffect } from "react";
// import PropTypes from "prop-types";
import clsx from "clsx";
import { lighten, makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import moment from "jalali-moment";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";

import {
  GetAdsCategories,
  GetAds,
  DeleteAds,
  AdsconfirmGet,
  GetProvinces,
  GetAllategories,
  GetCityByProvinceId,
  GetFilterAds,
  GetFilterAdssimple,
} from "../../fetchs";

import { Button } from "@material-ui/core";
// import SubdirectoryArrowRightIcon from '@material-ui/icons/SubdirectoryArrowRight';

import DeleteIcon from "@material-ui/icons/Delete";
import AlertDialog from "../Prompt/alert-dialog.component";
import CircularProgress from "@material-ui/core/CircularProgress";

import Addimage from "../../image-add.png";
import Modal from "@material-ui/core/Modal";
import { toast } from "react-toastify";

import Switch from "@material-ui/core/Switch";

const headCells = [
  { id: "imageAddress", numeric: false, disablePadding: true, label: "عکس" },
  { id: "name", numeric: false, disablePadding: true, label: " عنوان " },
  { id: "family", numeric: true, disablePadding: false, label: "قیمت" },
  { id: "family", numeric: true, disablePadding: false, label: "تاریخ" },

  { id: "phone", numeric: true, disablePadding: false, label: " شماره تماس " },
  { id: "phone", numeric: true, disablePadding: false, label: " دسته بندی" },
  { id: "gender", numeric: true, disablePadding: false, label: "فعالیت" },
  { id: "gender", numeric: true, disablePadding: false, label: "تاییدشده " },
  {
    id: "gender",
    numeric: true,
    disablePadding: false,
    label: "اطلاعات پرداخت ",
  },
  { id: "gender", numeric: true, disablePadding: false, label: " موارد بیشتر" },

  { id: "tools", numeric: false, disablePadding: true, label: "" },
];

const EnhancedTableHead = () => {
  //const { classes } = props;

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={"center"}
            padding={headCell.disablePadding ? "none" : "default"}
          >
            <TableSortLabel active={false}>{headCell.label}</TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === "light"
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  spacer: {
    flex: "1 1 100%",
  },
  actions: {
    color: theme.palette.text.secondary,
    width: "170px",
  },
  title: {
    flex: "0 0 auto",
  },
  formControl: {
    width: "150px",
  },
  link: {
    margin: "10px",
    lineHeight: "4",
  },
}));

const EnhancedTableToolbar = (props) => {
  const classes = useToolbarStyles();
  const { numSelected } = props;

  return (
    <Toolbar
      className={clsx(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >
      <div className={classes.title}>
        {
          <Typography variant="h6" id="tableTitle">
            لیست تبلیغات
          </Typography>
        }
      </div>
      <div className={classes.spacer} />
      {/* <div className={classes.actions}>
        <Link to='/main/ads' className={classes.link}>
          <Button variant='contained' color='primary'>
            ساخت تبلیغ جدید
          </Button>
        </Link>
      </div> */}
    </Toolbar>
  );
};

// EnhancedTableToolbar.propTypes = {
//   numSelected: PropTypes.number.isRequired,
// };
function rand() {
  return Math.round(Math.random() * 20) - 10;
}

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: "absolute",
    width: 400,
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  color: {
    color: "#635ee7",
    backgroundColor: "#2e1534",
  },
  color2: {
    color: "#fff",
    backgroundColor: "#F92B52",
    // color: "#bd5f00",
    // backgroundColor: "#085025",
  },
}));

const Ads = () => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [rowsLength, setrowsLength] = useState(0);
  const [rows, setrows] = useState([]);
  const [alertDialog, setalertDialog] = useState(false);
  const [deleteId, setdeleteId] = useState(null);
  const [loading, setloading] = useState(false);
  const classes = useStyles();

  const [modalStyle] = useState(getModalStyle);
  const [open, setOpen] = useState(false);
  const [open1, setopen1] = useState(false);
  const [description, setdescription] = useState(null);
  const [address, setaddress] = useState(null);
  const [render, setrender] = useState(false);
  const [categoryId, setcategoryId] = useState("");
  const [categories, setcategories] = useState([]);
  const [cities, setcities] = useState([]);
  const [cityId, setcityId] = useState("");
  const [province, setprovince] = useState([]);
  const [provinceId, setprovinceId] = useState("");
  const [amount, setamount] = useState("");
  const [isSucess, setisSucess] = useState(false);
  const [systemTraceNo, setsystemTraceNo] = useState("");
  const [retrivalRefNo, setretrivalRefNo] = useState("");
  const [payDateTime, setpayDateTime] = useState("");

  const handleChangeProvince = (event) => {};
  useEffect(() => {
    getCitiesByProvince();
  }, [provinceId]);

  const getCitiesByProvince = () => {
    GetCityByProvinceId(provinceId)
      .then((response) => {
        return response.json();
      })
      .then((responseJson) => {
        if (responseJson.Message) toast.error(responseJson.Message);
        else setcities(responseJson);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleOpen = (desc, address) => () => {
    setdescription(desc);
    setaddress(address);

    setOpen(true);
  };
  const handleOpen1 = (pay) => () => {
    setamount(pay.amount);
    setisSucess(pay.isSucess);
    setsystemTraceNo(pay.systemTraceNo);
    setretrivalRefNo(pay.retrivalRefNo);
    setpayDateTime(pay.payDateTime);

    setopen1(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleClose1 = () => {
    setopen1(false);
  };

  useEffect(() => {
    getAdsFromServer();
    getprovince();
    getcategory();
  }, [page, rowsPerPage]);

  const getprovince = () => {
    GetProvinces(0, 999)
      .then((response) => {
        setloading(false);
        return response.json();
      })
      .then((responseJson) => {
        if (responseJson.Message) toast.error(responseJson.Message);
        else setprovince(responseJson);
      })
      .catch((error) => {
        setloading(false);
        console.log(error);
      });
  };
  const getcategory = () => {
    GetAdsCategories(0, 999)
      .then((response) => {
        setloading(false);
        return response.json();
      })
      .then((responseJson) => {
        if (responseJson.Message) toast.error(responseJson.Message);
        else setcategories(responseJson.query);
      })
      .catch((error) => {
        setloading(false);
        console.log(error);
      });
  };

  const getAdsFromServer = () => {
    if (provinceId.length > 0 || cityId.length > 0 || categoryId.length > 0) {
      setloading(true);
      GetFilterAds(page, rowsPerPage, provinceId, cityId, categoryId)
        .then((response) => {
          setloading(false);
          return response.json();
        })
        .then((responseJson) => {
          setrows(responseJson);
          setrowsLength(responseJson.count);
        })
        .catch((error) => {
          setloading(false);
          console.log(error);
        });
    } else {
      setloading(true);
      GetFilterAdssimple(page, rowsPerPage)
        .then((response) => {
          setloading(false);
          return response.json();
        })
        .then((responseJson) => {
          setrows(responseJson.queryResult);
          setrowsLength(responseJson.count);
        })
        .catch((error) => {
          setloading(false);
          console.log(error);
        });
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleChange = (name) => (event) => {
    AdsconfirmGet(event.target.value)
      .then((response) => {
        if (response.status !== 200) {
          toast.error("خطای تایید تبلیغ");
        } else if (response.status === 200) {
          toast.success("تبلیغ با موفقیت تایید شد");
        }

        return response.json();
      })
      .then((responseJson) => {
        const idx = rows.findIndex(
          (rows) => rows.id === responseJson.result.id
        );
        rows.splice(idx, 1, responseJson.result);
        setrender(!render);
      })
      .catch((error) => {
        setloading(false);
        console.log(error);
      });
  };
  const handleDelete = () => {
    setloading(true);
    setalertDialog(false);

    DeleteAds(deleteId)
      .then((response) => {
        setloading(false);
        if (response.status === 200) toast.success("تبلیغ با موفقیت حذف شد");
        else toast.error("خطای حذف تبلیغ");
        getAdsFromServer();

        return response.json();
      })
      .then((responseJson) => {})
      .catch((error) => {
        console.log(error);
      });
  };

  const handlePrepareDelete = (id) => {
    setdeleteId(id);
    setalertDialog(true);
  };

  const handleCloseDialog = () => {
    setalertDialog(false);
  };
  const handleCategoryChange = (e) => {
    setcategoryId(e.target.value);
    getAdsFromServer();
  };

  const handleCityChange = (e) => {
    setcityId(e.target.value);
    getAdsFromServer();
  };

  return (
    <div className="root">
      <Paper className="paper">
        <EnhancedTableToolbar numSelected={0} />
        <div className="tableWrapper">
          <Grid
            spacing={1}
            container
            direction="row"
            justify="center"
            alignItems="flex-end"
          >
            <Grid item xs={12} sm={3}>
              <TextField
                id="standard-select-city"
                select
                label="استان"
                required
                fullWidth
                value={provinceId}
                onChange={(e) => {
                  setprovinceId(e.target.value);
                  getCitiesByProvince();
                }}
                margin="normal"
              >
                {province &&
                  province.map((option) => (
                    <MenuItem key={option.id} value={option.id}>
                      {option.name} - {option.province}
                    </MenuItem>
                  ))}
              </TextField>
            </Grid>
            <Grid item xs={12} sm={3}>
              <TextField
                id="standard-select-city"
                select
                label="شهر"
                required
                fullWidth
                value={cityId}
                onChange={(e) => {
                  setcityId(e.target.value);
                }}
                margin="normal"
              >
                {cities &&
                  cities.map((option) => (
                    <MenuItem key={option.id} value={option.id}>
                      {option.name} - {option.province}
                    </MenuItem>
                  ))}
              </TextField>
            </Grid>
            <Grid item xs={12} sm={3}>
              <TextField
                id="categoryId"
                name="categoryId"
                select
                label="دسته بندی"
                required
                fullWidth
                value={categoryId}
                // onClick={handleCategoryChange}
                onChange={(e) => {
                  setcategoryId(e.target.value);
                }}
                margin="normal"
              >
                <MenuItem value="">هیچکدام</MenuItem>
                {categories &&
                  categories.map((option) => (
                    <MenuItem key={option.id} value={option.id}>
                      {option.name}
                    </MenuItem>
                  ))}
              </TextField>
            </Grid>

            <Grid item xs={12} sm={1}>
              <Button
                onClick={() => getAdsFromServer()}
                // margin="normal"
                variant="contained"
                color="primary"
              >
                جستجو
              </Button>
            </Grid>
          </Grid>

          <Table className="table" aria-labelledby="tableTitle" size={"medium"}>
            <EnhancedTableHead
              classes={classes}
              numSelected={0}
              rowCount={rowsLength}
            />
            <TableBody>
              {rows.map((row, index) => {
                return (
                  <TableRow hover tabIndex={-1} key={index}>
                    <TableCell align="center">
                      {row.imgUrl === null ||
                      row.imgUrl === "" ||
                      row.imgUrl === "null" ? (
                        <img
                          src={`http://test.asa-oil.ir/${Addimage}`}
                          alt={row.name}
                          className="brandImage"
                        />
                      ) : (
                        <img
                          src={`http://test.asa-oil.ir/${row.imgUrl}`}
                          alt={row.name}
                          className="brandImage"
                        />
                      )}
                    </TableCell>
                    <TableCell align="center">{row.title}</TableCell>
                    <TableCell align="center">
                      {row.price === -1 ? "توافقی" : row.price}
                    </TableCell>
                    <TableCell align="center">
                      {moment(row.createDatetime, "YYYY/MM/DD")
                        .locale("fa")
                        .format("YYYY/MM/DD")}
                    </TableCell>
                    <TableCell align="center">{row.phoneNumber}</TableCell>
                    <TableCell align="center">{row.categoryName}</TableCell>

                    {row.isActive ? (
                      <TableCell align="center">
                        {/* <HighlightOffIcon /> */}
                        <CheckCircleIcon color="primary" />
                      </TableCell>
                    ) : (
                      <TableCell align="center">
                        <HighlightOffIcon />
                      </TableCell>
                    )}

                    <TableCell align="center">
                      <Switch
                        color="primary"
                        checked={row.isConfirm}
                        onChange={handleChange("isConfirm")}
                        name="isConfirmed"
                        value={row.id}
                        inputProps={{
                          "aria-label": "primary  checkbox",
                        }}
                      />
                    </TableCell>

                    <TableCell align="center">
                      <Button
                        disabled={!row.pay}
                        className={classes.color2}
                        variant={"contained"}
                        color="warning"
                        type="button"
                        onClick={handleOpen1(row.pay)}
                      >
                        اطلاعات پرداخت
                      </Button>
                      <Modal open={open1} onClose={handleClose1}>
                        <div style={modalStyle} className={classes.paper}>
                          <p className="text-right">
                            <b>هزینه : </b> {amount}
                          </p>
                          <p className="text-right">
                            <b>پرداخت : </b>
                            {isSucess ? "موفق" : "ناموفق"}
                          </p>
                          <p className="text-right">
                            <b>کد پیگیری : </b>
                            {systemTraceNo}
                          </p>
                          <p className="text-right">
                            <b>کد پرداخت : </b>
                            {retrivalRefNo}
                          </p>
                          <p className="text-right">
                            <b>تاریخ پرداخت : </b>
                            {payDateTime &&
                              moment(payDateTime, "YYYY/MM/DD hh:mm:ss")
                                .locale("fa")
                                .format("تاریخ : YYYY/MM/DD   ساعت : hh:mm:ss")}
                            {/* {payDateTime} */}
                          </p>
                        </div>
                      </Modal>
                    </TableCell>
                    <TableCell align="center">
                      <Button
                        className={classes.color}
                        variant={"contained"}
                        color="warning"
                        type="button"
                        onClick={handleOpen(row.desc, row.address)}
                      >
                        موارد بیشتر
                      </Button>
                      <Modal open={open} onClose={handleClose}>
                        <div style={modalStyle} className={classes.paper}>
                          <p className="text-right">
                            <b>توضیحات : </b> {description}
                          </p>
                          <p className="text-right">
                            <b>آدرس : </b>
                            {address}
                          </p>
                        </div>
                      </Modal>
                    </TableCell>

                    <TableCell align="center">
                      {/* <Link to={`/main/ads/${row.id}`}>
                        <EditIcon color='primary' />
                      </Link> */}

                      <DeleteIcon
                        className="deleteIcon"
                        onClick={() => handlePrepareDelete(row.id)}
                      />
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </div>
        {loading && <CircularProgress size={24} className="buttonProgress" />}
        <TablePagination
          rowsPerPageOptions={[20, 50, 100]}
          component="div"
          count={rowsLength}
          rowsPerPage={rowsPerPage}
          page={page}
          backIconButtonProps={{
            "aria-label": "previous page",
          }}
          nextIconButtonProps={{
            "aria-label": "next page",
          }}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Paper>
      <AlertDialog
        open={alertDialog}
        title={`اخطار`}
        body={`آیا از حذف داروخانه اطمینان دارید؟`}
        handleYes={handleDelete}
        handleNo={handleCloseDialog}
      />
    </div>
  );
};
export default Ads;
